import * as d3 from "d3";
import { interpolatePath } from "d3-interpolate-path";
import scrollama from "scrollama";
import firstdata from "dataset:../_data/crossings_2014_2023.csv";
import seconddata from "dataset:../_data/crossings_2000_2023.csv";
import thirddata from "dataset:../_data/undetected.csv";

document.addEventListener("DOMContentLoaded", function () {
    // Read in and process the data

    drawOpenerCharts(firstdata, seconddata, thirddata);
    drawBodyScrollies();

    function drawOpenerCharts(firstdata, seconddata, thirddata) {
        const parseDate = d3.timeParse("%Y");
        firstdata.forEach((d) => {
            d.date = parseDate(d.year);
            d.num = +d["southwest-crossings"];
        });

        seconddata.forEach((d) => {
            d.date = parseDate(d["year"]);
            d.num = +d["southwest-crossings"];
        });

        thirddata.forEach((d) => {
            d.date = parseDate(d.year);
            d.num = +d["undetected-crossings"];
            d.undetected = +d["undetected-crossings"];
            d.southwest = +d["southwest-crossings"];
            d.combined = d.undetected + d.southwest;
        });
        const estimatedata = thirddata.filter((d) => {
            return d.year == "2022" || d.year == "2023";
        });

        const keys = ["southwest-crossings", "undetected-crossings"];
        const stackedData = d3.stack().keys(keys)(thirddata);
        const stackedEstimateData = d3.stack().keys(keys)(estimatedata);

        // Set the dimensions and margins of the graph
        const margin = { top: 10, right: 20, bottom: 30, left: 30 },
            width = 340 - margin.left - margin.right,
            height = 400 - margin.top - margin.bottom;
        // Append the SVG object to the div
        const svg = d3
            .select("#opener-chart")
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // Initialize axes

        const tickArrays = {
            ticks1: [parseDate(2014), parseDate(2018), parseDate(2023)],
            ticks2: [parseDate(2000), parseDate(2010), parseDate(2023)],
        };

        const x = d3
            .scaleTime()
            .range([0, width])
            .domain(d3.extent(firstdata, (d) => d.date));
        const y = d3
            .scaleLinear()
            .range([height, 0])
            .domain([0, d3.max(firstdata, (d) => d.num) * 1.5]);
        const xAxis = d3.axisBottom(x).tickValues(tickArrays.ticks1);
        const yAxis = d3
            .axisLeft(y)
            .ticks(5)
            .tickValues([1000000, 2000000, 3000000, 4000000])
            .tickFormat((d) => {
                const formatted = d3.format(".2s")(d); // Format number with 2 significant digits
                return formatted.replace(/\.0/, ""); // Remove ".0" if present
            })
            .tickSize(20);

        const line = d3
            .line()
            .x((d) => x(d.date))
            .y((d) => y(d.num));

        const area = d3
            .area()
            .x((d) => x(d.date))
            .y0(y(0))
            .y1((d) => y(d.num));

        const areatwo = d3
            .area()
            .x(function (d) {
                return x(parseDate(d.data.year));
            })
            .y0(function (d) {
                return y(d[0]);
            })
            .y1(function (d) {
                return y(d[1]);
            });

        svg.append("g")
            .attr("class", "myXaxis")
            .attr("transform", `translate(0, ${height})`)
            .call(xAxis);

        svg.append("g")
            .attr("class", "myYaxis")
            .call(yAxis)
            .call((g) =>
                g
                    .selectAll(".tick text")
                    .attr("dy", "-0.5em")
                    .attr("dx", "1.1em"),
            )
            .call(
                (g) => g.selectAll(".tick line"),
                // .attr("transform", "translate(-2em, 0)"),
            );
        svg.append("path").attr("class", "undetected");
        svg.append("path").attr("class", "estimate");
        svg.append("path")
            .attr("class", "linechart")
            .attr("d", area(firstdata));

        svg.selectAll(".line-label")
            .data([firstdata]) // Array of arrays, in case you have multiple lines
            .enter()
            .append("text")
            .attr("class", "line-label")
            .attr("transform", (d) => {
                const lastPoint = d[d.length - 1]; // Get the last data point
                return `translate(${x(lastPoint.date)}, ${y(lastPoint.num)})`;
            })
            .attr("dx", "5") // Offset the text slightly from the end point
            .attr("dy", "0.35em") // Center text vertically
            .text((d) => d3.format(".2s")(d[d.length - 1].num)); // Use the value from the last data point as the label

        // svg.selectAll(".undetected-chart-label")
        //     .data([thirddata]) // Array of arrays, in case you have multiple lines
        //     .enter()
        //     .append("text")
        //     .attr("class", "undetected-chart-label")
        //     .attr("transform", (d) => {
        //         const lastPoint = d[d.length - 1]; // Get the last data point
        //         return `translate(${x(lastPoint.date)}, ${y(
        //             lastPoint.combined,
        //         )})`;
        //     })
        //     .attr("dx", "5") // Offset the text slightly from the end point
        //     .attr("dy", "0.35em") // Center text vertically
        //     .text((d) => d3.format(".2s")(d[d.length - 1].num)); // Use the value from the last data point as the label

        // Variable to hold the current dataset
        let currentData = firstdata;

        // Update function for the graph
        function update(newData) {
            d3.select(".opener-chart-box").classed("undetected", false);
            const oldData = currentData; // Store the previous data
            currentData = newData; // Update current data to the new dataset

            // Update the domains of the axes
            x.domain(d3.extent(newData, (d) => d.date));
            y.domain([0, d3.max(newData, (d) => d.num) * 1.5]);

            let ticksNum = "ticks1";
            let startDate = newData[0].year;
            if (startDate == "2014") {
                ticksNum = "ticks1";
            } else {
                ticksNum = "ticks2";
            }
            xAxis.tickValues(tickArrays[ticksNum]);

            // Update axes
            svg.select(".myXaxis").transition().duration(2000).call(xAxis);
            svg.select(".myYaxis").transition().duration(2000).call(yAxis);

            // Select the line path
            const linePath = svg.selectAll(".linechart").data([newData]);

            // Enter selection
            linePath
                .enter()
                .append("path")
                .attr("class", "linechart")
                .attr("d", area(oldData)) // Set initial line to old data
                .merge(linePath) // Merge with the update selection
                .transition()
                .duration(2000)
                .attrTween("d", () => {
                    const previousPath =
                        svg.select(".linechart").attr("d") || area(oldData);
                    const currentPath = area(newData);
                    return interpolatePath(previousPath, currentPath);
                });

            // Exit selection
            linePath
                .exit()
                .transition()
                .duration(10)
                .attr("opacity", 0)
                .remove();

            svg.select(".undetected").interrupt().attr("d", "");
            svg.select(".estimate").interrupt().attr("d", "");
        }

        function updateThird(newData) {
            d3.select(".opener-chart-box").classed("undetected", true);
            const oldData = currentData; // Store the previous data
            currentData = newData; // Update current data to the new dataset

            // Update the domains of the axes
            x.domain(d3.extent(thirddata, (d) => d.date));
            // y.domain([0, 4000000);

            xAxis.tickValues(tickArrays["ticks2"]);

            // Update axes
            svg.select(".myXaxis").transition().duration(10).call(xAxis);
            // svg.select(".myYaxis").transition().duration(10).call(yAxis);

            const undetectedPath = svg.select(".undetected").data(newData);
            undetectedPath
                .attr("d", areatwo(newData[0])) // Set initial line to old data
                .merge(undetectedPath) // Merge with the update selection
                .transition()
                .duration(2000)
                .attrTween("d", () => {
                    const previousPath =
                        svg.select(".undetected").attr("d") ||
                        areatwo(newData[0]);
                    const currentPath = areatwo(newData[1]);
                    return interpolatePath(previousPath, currentPath);
                });

            const estimatePath = svg
                .select(".estimate")
                .data(stackedEstimateData);
            estimatePath
                .attr("fill", "url(#diagonalHatch)")
                .attr("d", areatwo(stackedEstimateData[0])) // Set initial line to old data
                .merge(estimatePath) // Merge with the update selection
                .transition()
                .duration(2000)
                .attrTween("d", () => {
                    const previousPath =
                        svg.select(".estimate").attr("d") ||
                        areatwo(stackedEstimateData[0]);
                    const currentPath = areatwo(stackedEstimateData[1]);
                    return interpolatePath(previousPath, currentPath);
                });

            /// make sure the yellow part is at the 2nd step
            svg.select(".linechart").interrupt().attr("d", area(seconddata)); // Set initial line to old data
        }

        function updateFourth() {
            svg.select(".linechart").interrupt().attr("d", area(seconddata));
            svg.select(".undetected")
                .interrupt()
                .attr("d", areatwo(stackedData[1]));
            svg.select(".estimate")
                .interrupt()
                .attr("d", areatwo(stackedEstimateData[1]));
            d3.select(".opener-labels").classed("undetected", true);
            x.domain(d3.extent(seconddata, (d) => d.date));
            y.domain([0, d3.max(seconddata, (d) => d.num) * 1.5]);
            xAxis.tickValues(tickArrays["ticks2"]);
        }

        /// SCROLL STUFF
        const item = document.querySelector(".opener-scroll-item");
        const openerscrollySteps = item.querySelectorAll(
            ".openerscrolly-text .opener-step",
        );

        // initialize scrollama
        const openerScroller = scrollama();
        openerScroller
            .setup({
                step: openerscrollySteps,
                offset: 0.8,
            })
            .onStepEnter(handleStepEnter);

        function handleStepEnter(response) {
            if (response.index == 0) {
                update(firstdata);
            } else if (response.index == 1) {
                update(seconddata);
            } else if (response.index == 2) {
                updateThird(stackedData);
            } else if (response.index == 3) {
                updateFourth();
            }
        }

        function handleResize() {
            openerScroller.resize;
            const openerstickyItems = document.querySelectorAll(
                ".opener-sticky-item",
            );
            let wh = window.innerHeight;

            openerstickyItems.forEach(function (stickyItem) {
                let hHeight = stickyItem.clientHeight;
                let hTop = (wh - hHeight) / 2;
                stickyItem.style.top = hTop + "px";
            });
        }
        handleResize();
        window.addEventListener("resize", handleResize);
    }

    function setNationalityChart() {
        let chartNum;
        const nationalityChart = document.getElementById("sticky-chart_1");
        if (!window.matchMedia("(max-width: 900px)").matches) {
            chartNum = 1;
        } else {
            chartNum = 3;
        }
        nationalityChart.src =
            "https://static.propublica.org/projects/graphics/2024-immigration-data/chart-images/nationality_step" +
            chartNum +
            ".png";
    }

    function drawBodyScrollies() {
        setNationalityChart();
        const scrollys = document.querySelectorAll(".scroll-item");
        scrollys.forEach(function (scrollyitem, scrollyindex) {
            const scrollySteps = scrollyitem.querySelectorAll(
                ".scrolly-text .body-step",
            );
            const scroller = scrollama();

            //initialize scrollama
            scroller
                .setup({
                    step: scrollySteps,
                    offset: 0.5,
                })
                .onStepEnter((response) => {
                    if (!window.matchMedia("(max-width: 900px)").matches) {
                        if (scrollyindex == 0) {
                            nationalityChartHandleStepEnter(response);
                        }
                    }
                });

            function handleResizeBody() {
                scroller.resize;
                const stickyItems = document.querySelectorAll(".sticky-item");
                let wh = window.innerHeight;

                stickyItems.forEach(function (stickyItem) {
                    let hHeight = stickyItem.clientHeight;
                    let hTop = (wh - hHeight) / 2;
                    stickyItem.style.top = hTop + "px";
                });
            }

            handleResizeBody();
            window.addEventListener("resize", handleResizeBody);

            function nationalityChartHandleStepEnter(response) {
                let num = response.index + 1;
                var nationalityChart =
                    document.getElementById("sticky-chart_1");
                var guaElHonLabel = document.getElementById(
                    "chart-anno__gua_el_hon",
                );
                var otherCountriesLabel = document.getElementById(
                    "chart-anno__othercountries",
                );

                nationalityChart.src =
                    "https://static.propublica.org/projects/graphics/2024-immigration-data/chart-images/nationality_step" +
                    num +
                    ".png";

                if (num === 1) {
                    guaElHonLabel.style.display = "none";
                    otherCountriesLabel.style.display = "none";
                } else if (num === 2) {
                    guaElHonLabel.style.display = "block";
                    otherCountriesLabel.style.display = "none";
                } else if (num === 3) {
                    guaElHonLabel.style.display = "block";
                    otherCountriesLabel.style.display = "block";
                }
            }
        });
    }
});
